import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import type { ServiceCategory, CreateServiceCategoryInput, UpdateServiceCategoryInput } from '../types/entities';

// ==================
// MASSAGE CATEGORIES
// ==================

export function useMassageCategories() {
  return useQuery({
    queryKey: ['massage-categories'],
    queryFn: async () => {
      const response = await api.get('/api/admin/massage-categories');
      return response.data.data as ServiceCategory[];
    },
  });
}

export function useCreateMassageCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateServiceCategoryInput) => {
      const response = await api.post('/api/admin/massage-categories', data);
      return response.data.data as ServiceCategory;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['massage-categories'] });
    },
  });
}

export function useUpdateMassageCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateServiceCategoryInput }) => {
      const response = await api.put(`/api/admin/massage-categories/${id}`, data);
      return response.data.data as ServiceCategory;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['massage-categories'] });
    },
  });
}

export function useDeleteMassageCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/admin/massage-categories/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['massage-categories'] });
    },
  });
}

// ==================
// SOIN CATEGORIES
// ==================

export function useSoinCategories() {
  return useQuery({
    queryKey: ['soin-categories'],
    queryFn: async () => {
      const response = await api.get('/api/admin/soin-categories');
      return response.data.data as ServiceCategory[];
    },
  });
}

export function useCreateSoinCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateServiceCategoryInput) => {
      const response = await api.post('/api/admin/soin-categories', data);
      return response.data.data as ServiceCategory;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['soin-categories'] });
    },
  });
}

export function useUpdateSoinCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateServiceCategoryInput }) => {
      const response = await api.put(`/api/admin/soin-categories/${id}`, data);
      return response.data.data as ServiceCategory;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['soin-categories'] });
    },
  });
}

export function useDeleteSoinCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/admin/soin-categories/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['soin-categories'] });
    },
  });
}
